import { useState } from 'react'

import { Mode, VerticalOptions } from '../helper'

export const useCategorySearch = (): {
  searchedType: string | null
  searchedVerticals: VerticalOptions[]
  handleSearch: (search: string, options: PreDataProps, mode: Mode) => void
} => {
  const [searchedType, setSearchedType] = useState<string>('')
  const [searchedVerticals, setSearchedVerticals] = useState<VerticalOptions[]>(
    []
  )

  const onSearch = (
    search: string,
    options: PreDataProps,
    mode: Mode
  ): VerticalOptions[] => {
    if (!options) return []
    const result: VerticalOptions[] = []
    options.typeContentSelection.body.options.forEach(subCategories => {
      subCategories.options.forEach(vertical => {
        if (vertical.title.toLowerCase().includes(search.toLowerCase())) {
          if (mode === Mode.ADD_ASSIGNMENT) return
          result.push(vertical)
        }
      })
    })
    return result
  }

  const handleSearch = (search: string, options: PreDataProps, mode: Mode) => {
    if (!search) setSearchedType('')
    setSearchedType(search)
    setSearchedVerticals(onSearch(search, options, mode))
  }

  return { searchedType, searchedVerticals, handleSearch }
}
